import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { AreaChart } from '../../../shared';
import { CTR_CHART_OPTIONS } from './constants';

const CtrChart = () => {
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, ctrData } = dtcData;
    const [areaData, setAreaData] = useState([]);
    useEffect(() => {
        setAreaData(ctrData);
    }, [ctrData]);
    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Click Through Rate
                </Typography>
            </Box>
            <Box className="wh-100" id="engagement-deciles">
                {isWebMatrixPatientLoading ?
                    <Skeleton height={400} variant="rectangular" width="100%" /> :
                    <AreaChart
                        chartOptions={CTR_CHART_OPTIONS}
                        chartSeries={areaData}
                    />}
            </Box>
        </Box>
    );
};

export default CtrChart;
